import furnitureIcon from '../../../../assets/img/mobileMenuIcons/furniture.svg';
import furnitureIcon2 from '../../../../assets/img/mobileMenuIcons/furniture2.svg';
import furnitureIcon3 from '../../../../assets/img/mobileMenuIcons/furniture3.svg';
import collectionsIcon from '../../../../assets/img/mobileMenuIcons/collections.svg';
import premisesIcon from '../../../../assets/img/mobileMenuIcons/premises.svg';
import producersIcon from '../../../../assets/img/mobileMenuIcons/producers.svg';
import promotionsIcon from '../../../../assets/img/mobileMenuIcons/promotions.svg';
import contactIcon from '../../../../assets/img/mobileMenuIcons/contact-mail.svg';
import { INavigationButton } from '../../../../interfaces/INavigationButton';


export const navigationButtons: INavigationButton[] = [
    {
        name: 'Meble',
        url: '/meble',
        hasArrow: true,
        mobileIcon: furnitureIcon,
    },
    // {
    //     name: 'Meble na wymiar',
    //     url: '/meble-na-wymiar',
    //     hasArrow: true,
    //     mobileIcon: furnitureIcon3,
    // },
    {
        name: 'Meble importowane',
        url: '/meble-importowane',
        hasArrow: true,
        mobileIcon: furnitureIcon2,
    },
    {
        name: 'Kolekcje',
        url: '/kolekcje',
        hasArrow: true,
        mobileIcon: collectionsIcon,
    },
    {
        name: 'Pomieszczenia',
        url: '/pomieszczenia',
        hasArrow: true,
        mobileIcon: premisesIcon,
    },
    {
        name: 'Producenci',
        url: '/producenci',
        hasArrow: true,
        mobileIcon: producersIcon,
    },
    {
        name: 'Promocje',
        url: '/promocje',
        hasArrow: false,
        mobileIcon: promotionsIcon,
    },
    {
        name: 'Kontakt',
        url: '/kontakt',
        hasArrow: false,
        mobileIcon: contactIcon,
    },
]